import React, { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router';

import { useAppSelector } from '@/store';
import { pages } from '@/settings/pages';
import { authStore } from '@/store/auth';

export const GuestRoute: React.FC = () => {
  const hasSession = useAppSelector(authStore.selectors.hasSessionSelector);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasSession) {
      const from = location.state?.from || { pathname: pages.top };
      navigate(pages.top, { state: { from }, replace: true });
    }
  }, [hasSession, location, navigate]);

  return <Outlet />;
};
